import { ticketViewService } from "../../services/merpservices";

const _inFlight = new Map();

export const fetchTicketData = async (empid, ak, glid, condition = '') => {
    const key = `${glid}_${condition}`;
    if (_inFlight.has(key)) return _inFlight.get(key);

    const promise = ticketViewService(empid, ak, glid, condition)
        .then(res => res?.data?.status === 200 ? res.data.data : null)
        .catch(() => null)
        .finally(() => _inFlight.delete(key));

    _inFlight.set(key, promise);
    return promise;
}